import { adminHttpClient } from '../../commons/adminHttpClient'

export type ImpersonateResponse = {
  token: string
}

const impersonate = (userId: string): Promise<ImpersonateResponse> => {
  return adminHttpClient.post('/csi/Impersonate', {
    Id: userId,
  })
}

export default impersonate
